import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { CaseType, ICase } from '@brands/services/cases/types/ICase';
import { calculateDueDateAppointmentsPage } from '@brands/Utils/calculateDueDate';
import { getBubble_color } from '@brands/Utils/getPrimaryColor';
import Button from '@mui/material/Button';
import { darken } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';

import video_camera_icon from '../../assets/video_camera_icon.svg';
import styles from '../appointments.module.scss';

interface Props {
  appointment: ICase;
}

const syncCaseTypes: CaseType[] = [CaseType.video_call_scheduled, CaseType.oral_health_coaching];

const JoinButton = ({ appointment }: Props): JSX.Element => {
  const roleNavigate = useRoleNavigate();
  const [dueDate, setDueDate] = useState(true);
  const [remainingTime, setRemainingTime] = useState('');
  const isSyncCase = syncCaseTypes.includes(appointment.type);

  useEffect(() => {
    if (!appointment.video_conference_date) {
      setDueDate(false);
      setRemainingTime('');
      return () => {};
    }

    const updateDueDate = (): void => {
      const due = calculateDueDateAppointmentsPage(appointment.video_conference_date as string);
      setDueDate(due !== null);
      setRemainingTime(due || '');
    };

    updateDueDate();

    const interval = setInterval(() => {
      updateDueDate();
    }, 1000);

    return () => clearInterval(interval);
  }, [appointment.video_conference_date]);

  return (
    <Button
      className={`${styles.actionBtn} fs-unmask ${isSyncCase && dueDate && remainingTime ? styles.actionBtnJoin : ''}`}
      sx={{
        textTransform: 'none',
        backgroundColor: getBubble_color(),
        color: '#fff',
        '&:hover': {
          backgroundColor: darken(getBubble_color(), 0.15),
        },
      }}
      variant="contained"
      type="button"
      onClick={() => {
        roleNavigate(`/video-room/${appointment?.id}`, {
          state: {
            conversationSid:
              appointment.patient_care_advisor_conversation_sid ?? appointment.patient_provider_conversation_sid,
            status: appointment.status,
          },
        });
      }}
    >
      <img src={video_camera_icon} alt="video camera icon" className={styles.videoCameraIcon} />
      {isSyncCase ? (dueDate && remainingTime ? 'Join' : 'Waiting Room') : 'Join'}
    </Button>
  );
};

export default JoinButton;
